// @flow

import React from "react";

import LoginRequired from "../lib/LoginRequired";
import BaseSyncObjectForm from "../lib/BaseSyncObjectForm";
import type { UserProfile } from "../types/user_profile";

type Props = {
  setTitle: string => void,
  showBackButton: () => void,
  hideBackButton: () => void,
  user: UserProfile
};

class CreateSyncObjectView extends React.Component<Props> {
  componentWillMount = async () => {
    this.props.showBackButton();
    this.props.setTitle(`Create new SyncObject`);
  };

  render = () => {
    return <BaseSyncObjectForm {...this.props} objectName={null} />;
  };
}

export default LoginRequired(CreateSyncObjectView);



// WEBPACK FOOTER //
// ./src/views/CreateSyncObjectView.js